define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "./template/usersSelectTemplate.html",
  "./template/userItemTemplate.html",
], function (Marionette, $, Messenger, Properties, UsersSelectTemplate, UserItemTemplate) {
  "use strict";

  var UsersSelectView = {};

  UsersSelectView.userItemView = Marionette.ItemView.extend({
    className: "department-user",
    tagName: "tr",
    template: UserItemTemplate,
    triggers: {
      "click .user-remove-button": "user:remove",
    },
  });

  UsersSelectView.usersSelectView = Marionette.CompositeView.extend({
    template: UsersSelectTemplate,
    itemView: UsersSelectView.userItemView,
    itemViewContainer: "tbody",
    triggers: {
      "click .add-user-button": "user:add",
    },
    onDomRefresh: function () {
      $(".add-user-select", this.$el).select2({
        allowClear: true,
        placeholder: $.t("admin.department.addUserPlaceholder"),
      });
    },
    getUser: function () {
      var value = $(".add-user-select", this.$el).val();
      if (!value) {
        return 0;
      }
      return +value;
    },
  });

  return UsersSelectView;
});
